import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useMall } from "@/context/MallContext";
import { sellersOf } from "@/lib/sellers";
import { themeOf } from "@/lib/mall";

/**
 * A designer can't price a job without knowing who prints it. When you arrive with no shop picked,
 * this asks — one list, one click, and you're in that shop's version of the page.
 */
export function PickShopGate({ room, title, to }) {
    const { enter } = useMall();
    const navigate = useNavigate();
    const [rows, setRows] = useState(null);

    useEffect(() => { sellersOf(room).then(setRows); }, [room]);
    useEffect(() => {
        if (rows && rows.length === 1) { enter(rows[0], "gate"); navigate(`${to}?store=${rows[0].slug}`, { replace: true }); }
    }, [rows, enter, navigate, to]);

    if (!rows) return <div className="flex min-h-[50vh] items-center justify-center text-zinc-400"><Loader2 className="animate-spin" /></div>;

    return (
        <section className="mx-auto max-w-2xl px-4 py-16 sm:px-6" data-testid="pick-shop-gate">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">Step 1 of 1</p>
            <h1 className="mt-2 font-display text-3xl font-black tracking-tight text-zinc-900 sm:text-4xl">{title}</h1>
            <p className="mt-2 text-sm text-zinc-600">Prices, turnaround and pickup depend on the shop. Pick one to continue.</p>
            <div className="mt-6 border border-zinc-300 bg-white">
                {rows.map((c) => {
                    const t = themeOf(c);
                    return (
                        <button key={c.slug} data-testid={`gate-store-${c.slug}`}
                            onClick={() => { enter(c, "gate"); navigate(`${to}?store=${c.slug}`); }}
                            className="flex w-full items-center gap-3 border-b border-zinc-200 px-4 py-3 text-left transition-colors last:border-0 hover:bg-zinc-50">
                            <span className="h-3 w-3 shrink-0" style={{ background: t.primary }} />
                            <span className="font-display text-base font-bold text-zinc-900">{c.name}</span>
                            <span className="text-xs text-zinc-500">{c.city}</span>
                            <span className="ml-auto text-xs font-bold text-zinc-900">Order here →</span>
                        </button>
                    );
                })}
                {!rows.length && <p className="px-4 py-6 text-sm text-zinc-600" data-testid="gate-empty">No shop offers this yet.</p>}
            </div>
        </section>
    );
}
